import React, { FC, useEffect, useState } from 'react';


import { checkUserSystem } from '../../../utils/cryptoPro/checkUtils';
import IconBtn from '../../icon-btn/icon-btn';

import CloseIcon from './icons/close-icon.svg';

import './alert.scss';
import '../authorization.scss';

const Alert: FC = () => {
  const [isSystemError, setIsSystemError] = useState(false);

  useEffect(() => {
    checkUserSystem().then((res) => setIsSystemError(!res));
  }, []);

  const onClose = () => {
    setIsSystemError(false);
  };

  return isSystemError ? (
    <div className="authorization__alert">
      <div className="attention-no">
        <div className="attention-no__top">
          <div className="attention-no__left">
            <p className="text-2 attention-no__title">Внимание, нет плагина!</p>
          </div>
          <div className="attention-no__right">
            <IconBtn onClick={onClose} icon={CloseIcon} />
          </div>
        </div>
        <div className="attention-no__body">
          <p className="text-2">
            Для работы на площадке требуется{' '}
            усиленная цифровая подпись(УКЭП).{' '}
            Получите подпись и <a href="https://www.cryptopro.ru/products/cades/plugin" target="_blank" rel="noreferrer">установите плагин КриптоПро</a>, чтобы безопасно
            подписывать документы и совершать операции.
          </p>
        </div>
      </div>
    </div>
  ) : null;
};

export default Alert;
